var map = {
	"./pages/cartridge-air.vue": [
		"4bdc",
		"chunk-50b78b2b"
	],
	"./pages/cartridge-ict.vue": [
		"ddc5",
		"chunk-3f81fe66"
	],
	"./pages/cartridge-skin.vue": [
		"b68e",
		"chunk-13873576",
		"chunk-fb283a1e"
	],
	"./pages/contact.vue": [
		"c444",
		"chunk-b4e09f54"
	],
	"./pages/download.vue": [
		"bb20",
		"chunk-51170272"
	],
	"./pages/frame.vue": [
		"2873",
		"chunk-2c32c580"
	],
	"./pages/language-root.vue": [
		"3441",
		"chunk-2d0b9994"
	],
	"./pages/os.vue": [
		"d593",
		"chunk-de86bdfc"
	],
	"./pages/parallax-test.vue": [
		"c1d8",
		"chunk-13873576",
		"chunk-554a0f72"
	],
	"./pages/platform.vue": [
		"be97",
		"chunk-3a26bf52"
	],
	"./pages/works.vue": [
		"8acf",
		"chunk-40343d73"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "87e4";
module.exports = webpackAsyncContext;